module.exports = __webpack_public_path__ + "static/media/gif3.9737b9bc.gif";